import React, { Component } from 'react'
import { t } from 'i18next'

class RankingPosition extends Component {
  render() {
    const { position } = this.props
    const { name } = this.props

    return (
      <div className="flex-center position-holder">
        <div className="position-counter rounded rounded-sm flex-align-center rounded-position bg-blue">
          <span className="position-number">{position}</span>
        </div>
        <div className="position-info">
          <h5>{t('ranking.position')}</h5>
          <h3>{name}</h3>
        </div>
      </div>
    )
  }
}

export default RankingPosition



// WEBPACK FOOTER //
// ./src/components/rankingPosition.js